

//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  

/**
  * OrderItem Type - these should match up to Database Table: dbo.OrderItemType
  */
enum OrderItemType {

  /**
   * unknown
   */
  Unknown = 0,

  /**
   * reservation
   */
  Reservation = 1,

  /**
   * subscription
   */
  Subscription = 2,

  /**
   * fee
   */
  Fee = 3,

  /**
   * credit
   */
  Credit = 4,

  /**
   * permit
   */
  Permit = 5,

  /**
   * The extended lease discount
   */
  ExtendedLeaseDiscount = 6,

  /**
   * The background check
   */
  BackgroundCheck = 7,

  /**
   * Membership tier discount.
   */
  TierDiscount = 8,

  /**
   * Membership promo code
   */
  MembershipPromoCode = 9,

  /**
   * Booking Promo Code
   */
  BookingPromoCode = 10,

  /**
   * Portion of a lease that is allocated to paying for Outdoor Access Membership
   */
  LeaseMembership = 11,

  /**
   * Fees that are charged for a lease reservation
   */
  LeaseFee = 12,

}

export default OrderItemType;